import { z } from 'zod';

const mwCountrySchema = z.object({
  id: z.string(),
  isFromManager: z.boolean(),
  isActive: z.boolean(),
  code: z.string(),
  name: z.string(),
  isDefault: z.boolean(),
  callPrefix: z.string().optional(),
});

export const getMWCountriesSchema = z.array(mwCountrySchema);

export type GetMWCountries = z.infer<typeof getMWCountriesSchema>;
